export const ResourcesNames = {
  financial: 'Finances',
  administration: 'Marketing, recruitment & communication',
  dbe: 'Safety, hygiene & nutrition',
  other: 'Other',
};

export const ResourcesIcons = {
  financial: 'ClipboardListIcon',
  administration: 'SpeakerphoneIcon',
  dbe: 'ShieldCheckIcon',
  other: 'ViewGridIcon',
};

export const DataType = {
  dataFree: 'Data free',
  notDataFree: 'Not Data Free',
};

export const DataSortFilterOption = {
  mostLiked: 'Most liked',
  newest: 'Newest',
  oldest: 'Oldest',
  title: 'Title',
};

export const LikedFilterOption = {
  liked: 'Liked',
  notLiked: 'Not liked',
};
